<div [formGroup]="parentForm">
  <div class="da-card" formGroupName="personalDetails">
    <h3 class="card-title">Personal Details</h3>
    <div class="form-grid">

      <!-- First Name -->
      <div class="field-group">
        <label>First Name <span class="required">*</span></label>
        <input pInputText formControlName="firstName" placeholder="Enter first name"
          [class.ng-invalid]="isFieldInvalid(personalDetailsForm, 'firstName')"
          [class.ng-dirty]="isFieldInvalid(personalDetailsForm, 'firstName')" />
        <app-field-error [control]="personalDetailsForm.get('firstName')" type="personName"
          fieldName="First name"></app-field-error>
      </div>

      <!-- Last Name -->
      <div class="field-group">
        <label>Last Name <span class="required">*</span></label>
        <input pInputText formControlName="lastName" placeholder="Enter last name"
          [class.ng-invalid]="isFieldInvalid(personalDetailsForm, 'lastName')"
          [class.ng-dirty]="isFieldInvalid(personalDetailsForm, 'lastName')" />
        <app-field-error [control]="personalDetailsForm.get('lastName')" type="personName"
          fieldName="Last name"></app-field-error>
      </div>

      <!-- Date of Birth -->
      <div class="field-group">
        <label>Date of Birth <span class="required">*</span></label>
        <p-calendar formControlName="dob" [showIcon]="true" icon="pi pi-calendar" dateFormat="dd/mm/yy" appendTo="body"
          placeholder="DD/MM/YYYY" [class.ng-invalid]="isFieldInvalid(personalDetailsForm, 'dob')"
          [class.ng-dirty]="isFieldInvalid(personalDetailsForm, 'dob')" [style]="{'width':'100%'}">
        </p-calendar>
        <app-field-error [control]="personalDetailsForm.get('dob')" type="dobField"
          fieldName="Date of birth"></app-field-error>
      </div>

      <!-- Gender -->
      <div class="field-group">
        <label>Gender <span class="required">*</span></label>
        <p-dropdown formControlName="gender" [options]="genderOptions" appendTo="body" placeholder="Select gender"
          [class.ng-invalid]="isFieldInvalid(personalDetailsForm, 'gender')"
          [class.ng-dirty]="isFieldInvalid(personalDetailsForm, 'gender')" [style]="{'width':'100%'}">
        </p-dropdown>
        <app-field-error [control]="personalDetailsForm.get('gender')" type="requiredOnly"
          fieldName="Gender"></app-field-error>
      </div>

      <!-- Current Location (full width, autocomplete) -->
      <div class="field-group" style="grid-column: span 2;">
        <label>Current Location <span class="required">*</span></label>
        <p-autoComplete formControlName="currentLocation" [suggestions]="locationSuggestions"
          (completeMethod)="searchLocation($event)" field="description" placeholder="Search your location..."
          [baseZIndex]="3000" (onSelect)="onLocationSelect($event)" appendTo="body" [style]="{'width':'100%'}"
          [inputStyle]="{'width':'100%'}" [forceSelection]="false"
          [class.ng-invalid]="isFieldInvalid(personalDetailsForm, 'currentLocation')"
          [class.ng-dirty]="isFieldInvalid(personalDetailsForm, 'currentLocation')">
          <ng-template let-prediction pTemplate="item">
            <div class="white-space-normal" style="word-wrap: break-word;">
              {{ prediction.description }}
            </div>
          </ng-template>
        </p-autoComplete>
        <app-field-error [control]="personalDetailsForm.get('currentLocation')" type="requiredOnly"
          fieldName="Current location"></app-field-error>
      </div>

    </div>

    <!-- Save / Update Button Container -->
    <div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1rem;">
      <button pButton type="button" [label]="isDataExists ? 'Update' : 'Save'" icon="pi pi-check"
        class="p-button-sm p-button-primary"
        [loading]="isSaving"
        [disabled]="isSaving"
        style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
        (click)="savePersonalInfo()">
      </button>
    </div>
    <div class="unsaved-warning" *ngIf="personalDetailsForm.dirty">
      You have unsaved changes. Please click {{ isDataExists ? 'Update' : 'Save' }} to continue.
    </div>

  </div>
  <p-toast></p-toast>
</div>